/**
 * Friendly display names for `moduleId` — users should never see a raw "kali.*"/"zap.*"/"burp.*"
 * identifier in the UI (run progress, findings, scan-profile cards). Falls back to the raw
 * moduleId for anything not in this table (a module added later, before this table catches up)
 * rather than throwing or rendering blank.
 */
const MODULE_FRIENDLY_NAMES: Record<string, string> = {
  'kali.nmap': 'Port & service scan',
  'kali.nikto': 'Web vulnerability scan',
  'kali.whatweb': 'Technology fingerprint',
  'kali.gobuster': 'Directory discovery',
  'kali.nuclei': 'Vulnerability signatures',
  'kali.testssl': 'TLS deep scan',
  'kali.ldapdomaindump': 'AD structure enumeration',
  'kali.kerbrute': 'Kerberos user enumeration',
  'kali.enum4linux': 'SMB & NetBIOS scan',
  // Alias: the dispatched tool name is 'enum4linux-ng' (packages/shared/src/kali/tool-allowlist.ts)
  // but the parser's finding moduleId drops the '-ng' suffix (packages/kali-parsers/src/enum4linux.ts)
  // — QuickScan's scan-profile capability card displays the tool-name form, not the moduleId form.
  'kali.enum4linux-ng': 'SMB & NetBIOS scan',
  'kali.bloodhound': 'Attack path mapping',
  'kali.nessus': 'Vulnerability scan (Nessus)',
  'zap.scanner': 'Web application scan',
  'burp.scanner': 'Web application scan (Pro)',
  'external.weak-tls': 'TLS certificate check',
  'external.open-port-exposure': 'Open port scan',
  'external.config-exposure': 'Sensitive file check',
  'external.session-auth-hygiene': 'Session security check',
  'external.web-crawl-mapping': 'Web crawl & route mapping',
  'external.api-schema-ingestion': 'API schema discovery',
  'external.subdomain-takeover-risk': 'Subdomain takeover check',
  'external.authz-idor-bola': 'Authorization check',
  'external.safe-injection-signature': 'Injection detection',
  'external.safe-ssrf-oob': 'SSRF detection',
};

export function moduleFriendlyName(moduleId: string): string {
  return MODULE_FRIENDLY_NAMES[moduleId] ?? moduleId;
}
